import { render } from "./ProfilAksi.vue?vue&type=template&id=ca5b5a76"
import script from "./ProfilAksi.vue?vue&type=script&lang=js"
export * from "./ProfilAksi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__